
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.08 1.654H3.696V.967H7.08v.687zm3.204 0H8.062V.484A.487.487 0 007.572 0H3.202c-.27 0-.49.217-.49.483v1.171H.49A.487.487 0 000 2.137c0 .267.219.484.49.484h9.794a.488.488 0 00.492-.484.488.488 0 00-.492-.483zM9.194 3.16c-.27 0-.49.217-.49.483v7.318a.358.358 0 01-.36.355H2.432c-.199 0-.36-.159-.36-.355V3.643a.487.487 0 00-.491-.483.488.488 0 00-.492.483v7.318c0 .73.603 1.323 1.343 1.323h5.91c.742 0 1.343-.594 1.343-1.323V3.643a.487.487 0 00-.49-.483zM4.76 9.702V3.643a.487.487 0 00-.49-.483c-.271 0-.491.217-.491.483v6.06c0 .266.22.482.49.482s.49-.216.49-.483zm2.237 0V3.643a.488.488 0 00-.492-.483c-.27 0-.49.217-.49.483v6.06c0 .266.22.482.49.482a.488.488 0 00.492-.483z","fill":"#515358","fill-rule":"evenodd"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/trash.svg